export enum FormType {
  Input = 'input',
  Select = 'select',
  Custom = 'custom'
}
